import { CompanyExtension } from "@builder/types/Extension.type";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getAuthToken } from "jwt-storage-lib";

const COMPANY_EXTENSIONS_PATH = "/company-extensions";

export const companyExtensionsSlice = createApi({
    reducerPath: "companyExtensions",
    baseQuery: fetchBaseQuery({
        baseUrl: import.meta.env.VITE_HUB_API,
        prepareHeaders: async headers => {
            const token = await getAuthToken();

            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }

            return headers;
        }
    }),
    tagTypes: ["companyExtensions"],
    endpoints: builder => ({
        getCompanyExtensions: builder.query<CompanyExtension[], string>({
            query: companyId => `${COMPANY_EXTENSIONS_PATH}/${companyId}`,
            providesTags: ["companyExtensions"]
        })
    })
});

export const { useGetCompanyExtensionsQuery } = companyExtensionsSlice;
